import { Component } from '@angular/core';
import { detectBody } from '../../../app.helpers';

declare var jQuery:any;

@Component({
  selector: 'staff',
  templateUrl: 'staffLayout.template.html',
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class StaffLayoutComponent {

  public ngOnInit():any {
    detectBody();
  }

  public onResize(){
    detectBody();
  }

}
